<template>
  <div class="appContentEmpty">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "AppContentEmpty"
}
</script>

<style lang="scss" scoped>
$c: '.appContentEmpty';

#{$c} {
  &__title {
    margin: 24px 0;
  }

  @include respond-below(sm) {
    padding: 0 $--base-padding-sm;

    &__title {
      margin-left: 16px;
    }
  }
}
</style>